export default __webpack_public_path__ + "static/media/apply.2fce2543.png";